export const membersList = [
  {
    language: 'ko',
    list: [
      {
        url: '/images/members/ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/hoyoung-lee-leo-2a252958/',
        name: '이호영',
        position: 'CEO',
        previous: '주요 이력',
        experience: ['한양대학교 겸임교수', '삼성전자 MX사업부 책임연구원', '삼성 디자인 멤버십 UX 디자이너']
      },
      {
        url: '/images/members/cfo.webp',
        linkedIn: 'https://www.linkedin.com/in/%EA%B7%9C%EC%B2%A0-%EA%B9%80-305402226/',
        name: '김규철',
        position: 'CFO',
        previous: '주요 이력',
        experience: ['KAIST AIB', '한양대학교 겸임교수', '삼성전자 MX사업부 책임연구원', '삼성 소프트웨어 멤버십']
      },
      {
        url: '/images/members/cto.webp',
        linkedIn: 'https://www.linkedin.com/in/toonsquare-cto/',
        name: '최호섭',
        position: 'CTO',
        previous: '주요 이력',
        experience: ['KAIST AIB', '삼성전자 R&D 책임 엔지니어', '삼성 소프트웨어 멤버십 엔지니어']
      }
    ]
  },
  {
    language: 'en',
    list: [
      {
        url: '/images/members/ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/hoyoung-lee-leo-2a252958/',
        name: 'Hoyoung Lee',
        position: 'CEO',
        previous: 'Previous)',
        experience: [
          'Adjunct Professor at Hanyang University',
          "Senior Researcher at Samsung Electronics' MX Business",
          'UX Designer at Samsung Design Membership'
        ]
      },
      {
        url: '/images/members/cfo.webp',
        linkedIn: 'https://www.linkedin.com/in/%EA%B7%9C%EC%B2%A0-%EA%B9%80-305402226/',
        name: 'GyuCheul Kim',
        position: 'CFO',
        previous: 'Previous)',
        experience: [
          'KAIST AIB',
          'Visiting Professor at Hanyang University',
          "Senior Researcher at Samsung Electronics' MX Business",
          'Samsung Software Membership'
        ]
      },
      {
        url: '/images/members/cto.webp',
        linkedIn: 'https://www.linkedin.com/in/toonsquare-cto/',
        name: 'Hosub Choi',
        position: 'CTO',
        previous: 'Previous)',
        experience: ['KAIST AIB', 'R&D Lead Engineer at Samsung Electronics', 'Engineer at Samsung Software Membership']
      }
    ]
  },
  {
    language: 'fr',
    list: [
      {
        url: '/images/members/ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/hoyoung-lee-leo-2a252958/',
        name: 'Hoyoung Lee',
        position: 'CEO',
        previous: 'Ancien)',
        experience: [
          "professeur auxiliaire à l'université Hanyang",
          'Institut de recherche responsable de la division MX de Samsung Electronics',
          'Designer UX Samsung Design Membership'
        ]
      },
      {
        url: '/images/members/cfo.webp',
        linkedIn: 'https://www.linkedin.com/in/%EA%B7%9C%EC%B2%A0-%EA%B9%80-305402226/',
        name: 'GyuCheul Kim',
        position: 'CFO',
        previous: 'Ancien)',
        experience: [
          'KAIST AIB',
          "professeur auxiliaire à l'université Hanyang",
          'Institut de recherche responsable de la division MX de Samsung Electronics',
          'SIngénieur membership aux logiciels Samsung'
        ]
      },
      {
        url: '/images/members/cto.webp',
        linkedIn: 'https://www.linkedin.com/in/toonsquare-cto/',
        name: 'Hosub Choi',
        position: 'CTO',
        previous: 'Ancien)',
        experience: ['KAIST AIB', 'Ingénieur principal R&D de Samsung Electronics', 'Ingénieur membership aux logiciels Samsung']
      }
    ]
  },
  {
    language: 'jp',
    list: [
      {
        url: '/images/members/ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/hoyoung-lee-leo-2a252958/',
        name: 'Hoyoung Lee',
        position: 'CEO',
        previous: '前)',
        experience: ['漢陽大学校 兼任教員', 'サムスン電子 MX事業部責任研究員', 'サムスンデザインメンバーシップ UXデザイナー']
      },
      {
        url: '/images/members/cfo.webp',
        linkedIn: 'https://www.linkedin.com/in/%EA%B7%9C%EC%B2%A0-%EA%B9%80-305402226/',
        name: 'GyuCheul Kim',
        position: 'CFO',
        previous: '前)',
        experience: ['KAIST AIB', '漢陽大学校 兼任教員', 'サムスン電子 MX事業部責任研究員', 'サムスンソフトウェアメンバーシップ']
      },
      {
        url: '/images/members/cto.webp',
        linkedIn: 'https://www.linkedin.com/in/toonsquare-cto/',
        name: 'Hosub Choi',
        position: 'CTO',
        previous: '前)',
        experience: ['KAIST AIB', 'サムスン電子 R&D 責任エンジニア', 'サムスンソフトウェアメンバーシップ エンジニア']
      }
    ]
  }
];

export const advisorsList = [
  {
    language: 'ko',
    list: [
      {
        url: '/images/members/energex-ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/seanpark153/',
        name: '박성현',
        position: '',
        previous: '',
        experience: ['에너지엑스 대표', '타파스미디어 이사회 이사']
      }
    ]
  },
  {
    language: 'en',
    list: [
      {
        url: '/images/members/energex-ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/seanpark153/',
        name: 'Sean Park',
        position: '',

        previous: '',
        experience: ['CEO, Energy X', 'Board Member, Tapas Media']
      }
    ]
  },
  {
    language: 'fr',
    list: [
      {
        url: '/images/members/energex-ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/seanpark153/',
        name: 'Sean Park',
        position: '',
        previous: '',
        experience: ['CEO, Energy X', 'Board Member, Tapas Media']
      }
    ]
  },
  {
    language: 'jp',
    list: [
      {
        url: '/images/members/energex-ceo.webp',
        linkedIn: 'https://www.linkedin.com/in/seanpark153/',
        name: 'Sean Park',
        position: '',
        previous: '',
        experience: ['CEO, Energy X', 'Tapas Media取締役']
      }
    ]
  }
];
